import Button, { ButtonVariants } from '@/components/atoms/Button/Button';
import Snackbar from '@/components/atoms/legacy/Snackbar';
import FormInput from '@/components/molecules/FormInput';
import { validateEmail } from '@/lib/validators';
import React, { useState } from 'react';

type SnackbarType = 'SUCCESS' | 'ERROR';
interface SnackbarConfig {
  message: string;
  type: SnackbarType;
}

export const SubscribeBlog: React.FC = () => {
  const [userEmail, setUserEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarConfig, setSnackbarConfig] = useState<SnackbarConfig>({
    message: '',
    type: 'SUCCESS',
  });

  const handleSetEmail = (value: string) => {
    setUserEmail(value);
  };

  const submitEmail = async () => {
    if (userEmail === '') {
      setSnackbarConfig({
        message: 'Email is required',
        type: 'ERROR',
      });
      setShowSnackbar(true);
      return;
    }
    if (!validateEmail(userEmail)) {
      setSnackbarConfig({
        message: 'Email is invalid, please try a different email',
        type: 'ERROR',
      });
      setShowSnackbar(true);
      return;
    }

    setIsSubmitting(true);

    try {
      const res = await fetch(`/api/subscribe/?userEmail=${userEmail}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (res.status === 200) {
        setSnackbarConfig({
          message: 'Email submitted successfully!',
          type: 'SUCCESS',
        });
        setUserEmail('');
      } else {
        setSnackbarConfig({
          message: `Error: ${res.statusText}`,
          type: 'ERROR',
        });
      }
    } catch {
      setSnackbarConfig({
        message: 'Error: Something went wrong',
        type: 'ERROR',
      });
    }
    setShowSnackbar(true);
    setIsSubmitting(false);
  };

  return (
    <>
      <style jsx>{`
        .subscribe-form {
          background: radial-gradient(
            100% 100% at bottom right,
            #73e0a9 0%,
            #010044 100%
          );
        }
        @media (min-width: 768px) {
          background: radial-gradient(
            100% 100% at center,
            #73e0a9 0%,
            #010044 100%
          );
        }
      `}</style>
      <section className="subscribe-form flex flex-col gap-[20px] rounded-[20px] p-[20px] ml:px-xl ml:py-[52px] l:flex-row l:items-center l:justify-between lg:px-[48px]">
        <h2 className="text-h4SemiBold text-white ml:text-h2SemiBold">
          Subscribe for EV News and Reviews
        </h2>
        <section className="flex flex-col items-center gap-s m:flex-row">
          <div className="w-full m:min-w-[292px]">
            <FormInput
              variant="primary"
              className="w-full"
              value={userEmail}
              onChange={handleSetEmail}
              placeholder="Your email address"
            />
          </div>
          <div className="w-full m:flex-initial">
            <Button
              variant={ButtonVariants.Tertiary}
              aria-label="Subscribe"
              disabled={isSubmitting}
              loading={isSubmitting}
              onClick={submitEmail}
            >
              Subscribe
            </Button>
          </div>
        </section>
        <Snackbar
          isVisible={showSnackbar}
          setIsVisible={setShowSnackbar}
          type={snackbarConfig.type}
          message={snackbarConfig.message}
        />
      </section>
    </>
  );
};
